/**
 * API functions for Enhanced Automated Stories V2 module.
 */

import api from './api';

// Integration Status
export const integrationsAPI = {
  getStatus: () => api.get('/stories-v2/integrations/status'),
  saveCredential: (service, data) => api.post(`/stories-v2/integrations/${service}/save`, data),
  testConnection: (service) => api.post(`/stories-v2/integrations/${service}/test`),
};

// WordPress Connections
export const wordpressAPI = {
  getConnections: () => api.get('/stories-v2/wordpress-connections'),
  createConnection: (data) => api.post('/stories-v2/wordpress-connections', data),
  testConnection: (connectionId) => api.post(`/stories-v2/wordpress-connections/${connectionId}/test`),
  deleteConnection: (connectionId) => api.delete(`/stories-v2/wordpress-connections/${connectionId}`),
};

// Story Templates
export const templatesV2API = {
  getAll: (params) => api.get('/stories-v2/templates', { params }),
  getOne: (id) => api.get(`/stories-v2/templates/${id}`),
  create: (data) => api.post('/stories-v2/templates', data),
  update: (id, data) => api.put(`/stories-v2/templates/${id}`, data),
  delete: (id) => api.delete(`/stories-v2/templates/${id}`),
  run: (id, data = {}) => api.post(`/stories-v2/templates/${id}/run`, data),
  schedule: (id, data) => api.post(`/stories-v2/templates/${id}/schedule`, data),
  unschedule: (id) => api.delete(`/stories-v2/templates/${id}/schedule`),
};

// Schedules
export const schedulesAPI = {
  getAll: () => api.get('/stories-v2/schedules'),
};

// Run History
export const runsV2API = {
  getAll: (params) => api.get('/stories-v2/runs', { params }),
  getOne: (id) => api.get(`/stories-v2/runs/${id}`),
};

// Held Queue
export const heldQueueAPI = {
  getAll: () => api.get('/stories-v2/held-queue'),
  review: (id, data) => api.post(`/stories-v2/held-queue/${id}/review`, data),
};

// Stats
export const statsV2API = {
  get: () => api.get('/stories-v2/stats'),
};
